import React, {useEffect, useState} from 'react';
import {isBoolTrue} from "../utils/ReactUtils";
import {CircleLoading, NullMsgLabel} from "../index";

/**
 * Create a loading-section that has a loader & message-label.
 *
 * @example
 * <LoadingSection
 *      success={getJsonValue(dataLoadingStates, 'success')}
 *      loading={getJsonValue(dataLoadingStates, 'loading')}
 *      msg={getJsonValue(dataLoadingStates, 'msg')}
 * />
 *
 * @param {string} className - container className.
 * @param {string} labelClassName - Msg-label className.
 * @param {string|number} heightClass - Height className for panel.
 * @param {string|boolean} loading - Whether data has been loading or not (default: false).
 * @param {string|boolean} success - Whether data fetching process was successful or not (default: false).
 * @param {string|boolean} msgOnFailureOnly - Whether to the message only on failure (default: false).
 * @param {string|any} msg - Message to show in the label field (default: null).
 * @param {object} style - Styles for the container.
 */
const LoadingSection = React.memo(({
                                       // loadingStatus = {},
                                       className = "",
                                       labelClassName = "",
                                       heightClass = "100",
                                       loading = false,
                                       success = false,
                                       msg = '',
                                       color = '',
                                       style = {},
                                       showLoadingCircle = true,
                                   }) => {
    const TAG = "LoadingSection";

    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        // setHasLoaded(isBoolTrue(loading));
        // printLog(TAG, 'loading:', loading, 'success:', success, 'msg:', msg);
    }, [loading, success, msg]);


    return (<>
        {(isBoolTrue(loading) || !isBoolTrue(success)) &&
            <div className={`section h-${heightClass} borderless p-0 m-0 mt-2 d-flex jc-center al-center ${className}`}
                 style={{...style}}>
                {(isBoolTrue(loading) && isBoolTrue(showLoadingCircle)) && <CircleLoading wrapperClassName={'m-1'}/>}

                {!isBoolTrue(loading) && <NullMsgLabel className={labelClassName} color={color}>{msg + ''}</NullMsgLabel>}
            </div>}
    </>)
});
export default LoadingSection;
